<template>
    <v-app>

        <v-navigation-drawer right app temporary fixed v-model="sideNav" flat>
            <v-app-bar color="#CCCCCB">
                <v-app-bar-nav-icon  class="black--text" @click="toggleSideNav"></v-app-bar-nav-icon>
                <router-link to="/" tag="span" style="cursor: pointer">
                    <h1 class="title pr-2">
                        <img src="./assets/cookation-logo.png" alt="Cookation" width="200">
                    </h1>
                </router-link>
            </v-app-bar>

            <v-divider></v-divider>

            <v-list>
                <v-list-item ripple v-for="item in sideNavBarItems" :key="item.title" :to="item.link">
                    <v-list-item-icon>
                        <v-icon color="#252625">{{ item.icon }}</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        {{item.title}}
                    </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="user" @click="handleSignOut">
                    <v-list-item-icon>
                        <v-icon color="#252625">mdi-exit-to-app</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        تسجيل الخروج
                    </v-list-item-content>
                </v-list-item>


            </v-list>

        </v-navigation-drawer>


        <!-- Horizantal Navbar -->
        <v-app-bar fixed color="primary">
            <v-app-bar-nav-icon  class="black--text" @click="toggleSideNav"></v-app-bar-nav-icon>
            <v-toolbar-title class="hidden-xs-only">
                <router-link to="/" tag="span" style="cursor: pointer">
                    <img src="./assets/cookation-logo.png" alt="Cookation" width="200">
                </router-link>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-text-field flex prepend-icon="mdi-magnify" outlined dense placeholder="البحث عن طبخة" color="#252625"
                hide-details v-model="searchTerm"></v-text-field>

                <v-btn color="#252625" class="ma-2 white--text" justify-center @click="handleSearchCooks">بحث</v-btn>

            <v-spacer></v-spacer>

            <v-toolbar-items class="hidden-sm-and-down">
                <v-btn text color="#252625" v-for="item in horizantalNavBarItems" :key="item.title" :to="item.link">
                    <v-icon color="#252625" left class="hidden-sm-only">{{item.icon}}</v-icon>
                    {{item.title}}
                </v-btn>

                <!-- profile button -->
                <v-btn color="#252625" text to="/about" v-if="user">
                    <v-icon class="hidden-sm-only" left>mdi-information</v-icon>
                    <v-badge right color="blue darken-2">
                        <!-- <span slot="badge">1</span> -->
                        فكرة الموقع 
                    </v-badge>
                </v-btn>

                <!-- Signout button -->
                <v-btn color="#252625" text v-if="user" @click="handleSignOut">
                    <v-icon class="hidden-sm-only" left>mdi-exit-to-app</v-icon>
                    <v-badge right color="blue darken-2">
                        <!-- <span slot="badge">1</span> -->
                        تسجيل الخروج
                    </v-badge>
                </v-btn>

            </v-toolbar-items>

            <!-- <v-menu class="hidden-md-and-up">
                <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                <v-list>
                    <v-list-tile v-for="item in horizantalNavBarItems" :key="item.title">
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu> -->
        </v-app-bar>


        <main>
            <v-container fluid class="mt-12 custom">
                <transition name="fade">
                    <router-view />
                </transition>

                <!-- Auth snackbar -->
                <v-snackbar v-model="authSnackbar" color="success" :timeout="6000" bottom left>
                    <v-icon class="mr-3">mdi-check-circle</v-icon>
                    <h3>أنت متصل الآن</h3>
                    <v-btn light text @click="authSnackbar = false">إغلاق</v-btn>
                </v-snackbar>

                <!-- Auth error snackbar -->
                <v-snackbar v-if="authError" v-model="authErrorSnackbar" color="warning" :timeout="6000" bottom left>
                    <v-icon class="mr-3">mdi-cancel</v-icon>
                    <h3>{{authError.message}}</h3>
                    <v-btn light text to="/signin">تسجيل الدخول</v-btn>
                </v-snackbar>

            <!-- <div id="adsgoeshere" class="advertise" v-html="adsenseContent"></div> -->
            </v-container>
        </main>

        <!-- <app-footer/> -->
    </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Footer from '../src/components/Shared/Footer'

    export default {
        data() {
            return {
                searchTerm: '',
                sideNav: false,
                authSnackbar: false,
                authErrorSnackbar: false,
                adsenseContent: ''
            }
        },
        watch: {
            user(newvalue, oldValue) {
                if (oldValue === null) {
                    this.authSnackbar = true
                }
            },
            authError(value) {
                // If auth error is not null, show auth error  
                if (value !== null) {
                    this.authErrorSnackbar = true
                }
            }
        },
        name: 'App',
        components: {
            'app-footer': Footer
        },
        computed: {
            ...mapGetters(['authError', 'user']),

            horizantalNavBarItems() {
                let items = [{
                        icon: 'mdi-message-text',
                        title: 'كل الطبخات',
                        link: '/cooks'
                    },
                    {
                        icon: 'mdi-lock',
                        title: 'تسجيل الدخول',
                        link: '/signin'
                    },
                    {
                        icon: 'mdi-account',
                        title: 'إنشاء حساب',
                        link: '/signup'
                    }
                ]

                if (this.user) {
                    items = [{
                        icon: 'mdi-message-text',
                        title: 'كل الطبخات',
                        link: '/cooks'
                    }, ]
                }

                return items
            },
            sideNavBarItems() {
                let items = [{
                        icon: 'mdi-message-text',
                        title: 'كل الطبخات',
                        link: '/cooks'
                    },
                    {
                        icon: 'mdi-information',
                        title: 'فكرة الموقع',
                        link: '/about'
                    },
                    {
                        icon: 'mdi-lock',
                        title: 'تسجيل الدخول',
                        link: '/signin'
                    },
                    {
                        icon: 'mdi-account',
                        title: 'إنشاء حساب',
                        link: '/signup'
                    }
                ]

                if (this.user) {
                    items = [{
                            icon: 'mdi-message-text',
                            title: 'كل الطبخات',
                            link: '/cooks'
                        },
                        {
                            icon: 'mdi-plus-circle',
                            title: 'إضافة طبخة',
                            link: '/cook/add'
                        },
                        {
                            icon: 'mdi-chef-hat',
                            title: 'طبخاتي',
                            link: '/mycooks'
                        },
                        {
                            icon: 'mdi-account',
                            title: 'الملف الشخصي',
                            link: '/profile'
                        },
                        {
                            icon: 'mdi-information',
                            title: 'فكرة الموقع',
                            link: '/about'
                        }
                    ]

                    if(this.user.role === 'admin') {
                        items.push({
                            icon: 'mdi-plus-circle',
                            title: 'لوحة التحكم',
                            link: '/dashboard'
                        },
                        {
                            icon: 'mdi-plus-circle',
                            title: 'المستخدمين',
                            link: '/users'
                        })
                    }
                }

                return items
            }
        },
        mounted() {
            this.adsenseContent = document.getElementById('divadsensedisplaynone').innerHTML
        },
        methods: {
            handleSearchCooks() {
                this.$store.dispatch('searchCooks', {
                    query: this.searchTerm
                })
                this.searchTerm = null
            },
            handleSignOut() {
                this.$store.dispatch('signout')
            },
            toggleSideNav() {
                this.sideNav = !this.sideNav
            }
        }
    };
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Almarai&display=swap');

    .fade-enter-active,
    .fade-leave-active {
        transition-property: all;
        transition-duration: 0.25s
    }

    .fade-enter-active {
        transition-delay: 0.25s;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
        transform: translateY(-25px);
    }

    #app {
        font-family: 'Almarai', sans-serif !important;
        /* this was it */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .advertise {
        background: #1d1f29;
        padding-top:60px;
        text-align: center;
    }

    .custom {
        height:auto !important; /* real browsers */
        height:100%; /* IE6: treaded as min-height*/
        min-height:100vh; /* real browsers */
    }

  .v-text-field__slot input {
    color: black
  }
</style>